import React from "react";
import "./outlinedButton.scss";

interface OutlinedButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
}

const OutlinedButton = ({
  children,
  onClick,
  fullWidth = false,
  disabled = false,
}: OutlinedButtonProps) => (
  <button
    className={`outlined-button ${fullWidth ? "outlined-button--full" : ""}`}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export default OutlinedButton;
